module.exports = __webpack_public_path__ + "img/goodw3.bd320438.png";